import { Tag, Typography } from "antd";

// Shape shared by report-component rows and per-answer KPI result rows.
export interface VsTargetRow {
  readonly vsTargetBand?: string | null;
  readonly vsTargetColor?: string | null;
  readonly vsTargetDelta?: number | null;
}

function arrowFor(band?: string | null): string {
  switch (band) {
    case "Below target":
      return "⬇";
    case "Above target":
      return "⬆";
    case "On target":
      return "●";
    default:
      return "";
  }
}

// Renders the vs-Target verdict as an antd Tag: direction arrow + band text + (Δ) when present.
// Returns a muted em dash when there is no band (target comparison not available for the row).
export function renderVsTarget(row: VsTargetRow) {
  if (!row || !row.vsTargetBand) {
    return <Typography.Text type="secondary">—</Typography.Text>;
  }
  const arrow = arrowFor(row.vsTargetBand);
  const delta =
    row.vsTargetDelta != null
      ? ` (${row.vsTargetDelta > 0 ? "+" : ""}${row.vsTargetDelta.toFixed(1)})`
      : "";
  return (
    <Tag color={row.vsTargetColor ?? undefined}>
      {arrow ? `${arrow} ` : ""}
      {row.vsTargetBand}
      {delta}
    </Tag>
  );
}
